var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: { "offset-y": "", left: "" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "hidden-sm-and-down",
                    attrs: { color: "navbar", round: "" },
                  },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "mr-1", attrs: { medium: "" } }, [
                    _vm._v("admin_panel_settings"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { "text-align": "left" } }, [
                    _vm._v(_vm._s(_vm.$t("Button.SystemAdministration"))),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "hidden-md-and-up",
                    attrs: { color: "navbar", icon: "" },
                  },
                  on
                ),
                [
                  _c("v-icon", { attrs: { medium: "" } }, [
                    _vm._v("admin_panel_settings"),
                  ]),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-list",
            { attrs: { dense: "", dark: "" } },
            [
              _c("v-subheader", [_vm._v("Manage Access")]),
              _vm._v(" "),
              _vm._l(_vm.user, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.title,
                    attrs: { "active-class": "activeLink", to: item.router },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-subheader", [_vm._v("Manage Data")]),
              _vm._v(" "),
              _vm._l(_vm.mediaType, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.title,
                    attrs: { "active-class": "activeLink", to: item.router },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm._l(_vm.guideline, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.title,
                    attrs: { "active-class": "activeLink", to: item.router },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-subheader", [_vm._v("Manage Services")]),
              _vm._v(" "),
              _vm._l(_vm.services, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.title,
                    attrs: { "active-class": "activeLink", to: item.router },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-subheader", [_vm._v("Ingestion Management")]),
              _vm._v(" "),
              _vm._l(_vm.ingestion, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.title,
                    attrs: { "active-class": "activeLink", to: item.router },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-subheader", [_vm._v("Logs")]),
              _vm._v(" "),
              _vm._l(_vm.logs, function (item) {
                return _c(
                  "v-list-tile",
                  {
                    key: item.title,
                    attrs: { "active-class": "activeLink", to: item.router },
                  },
                  [
                    _c(
                      "v-list-tile-avatar",
                      [_c("v-icon", [_vm._v(_vm._s(item.icon))])],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile-content",
                      [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.adminPlugins.length > 0
                ? [
                    _c("v-subheader", [_vm._v("Manage Other")]),
                    _vm._v(" "),
                    _vm._l(_vm.adminPlugins, function (plugin) {
                      return _c(
                        "v-list-tile",
                        {
                          key: plugin.service.serviceLink,
                          attrs: {
                            to: {
                              name: "adminPlugins",
                              params: {
                                serviceLink: plugin.service.serviceLink,
                                interfaceType:
                                  _vm.PLUGIN_INTERFACE_TYPES.SYS_ADMIN,
                              },
                            },
                            "active-class": "activeLink",
                          },
                        },
                        [
                          _c(
                            "v-list-tile-avatar",
                            [
                              _c("v-icon", [
                                _vm._v(
                                  _vm._s(
                                    plugin.interfaces[
                                      _vm.PLUGIN_INTERFACE_TYPES.SYS_ADMIN
                                    ].icon
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-content",
                            [
                              _c("v-list-tile-title", [
                                _vm._v(
                                  _vm._s(
                                    plugin.interfaces[
                                      _vm.PLUGIN_INTERFACE_TYPES.SYS_ADMIN
                                    ].linkName
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }